import {CommunicationUtilisateurParLangueDto} from './CommunicationUtilisateurParLangueDto';

/**
 * Dto qui contient un message aux utilisateurs pour une langue donnée.
 */
export class CommunicationUtilisateurDto {
	couleur: string;
	messageParLangue: CommunicationUtilisateurParLangueDto[];

	serialize(): any {
		return Object.assign({}, this);
	}

	deserialize(input: any): CommunicationUtilisateurDto {
		Object.assign(this, input);
		if (input.messageParLangue) {
			this.messageParLangue = input.messageParLangue.map(communication => new CommunicationUtilisateurParLangueDto().deserialize(communication));
		}

		return this;
	}
}
